import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import { Modal, Upload } from 'components';
import { isNil } from 'lodash';
import { updateFormField } from 'store/forms/actions';

const UploadSingleFileModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
  title,
  description,
  Icon,
  payload = {},
  cancelText,
  okText,
  fileAccepts,
  files,
  fileCode = "modalFile"
}) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const [resetUpload, setResetUpload] = useState(false);

  const [uploadForm, setUploadForm] = useState(null);

  const clearModal = () => {
    setUploadForm();
    dispatch(
      updateFormField({
        group: 'documents',
        key: fileCode,
        value: null,
      })
    );
    setResetUpload(prev => !prev);
  };

  const handleFileOld = file => {
    if (file) {
      const form = new FormData();
      form.append('file', file);
      setUploadForm(form);
    } else {
      setUploadForm(null);
    }
    return;
  };

  const handleFile = file => {
    if (file) {
      const existingFiles = files || []; // or props.files, or from state
  
      const fileExists = existingFiles.some(f => f.name === file.name);
  
      let newFile = file;
  
      if (fileExists) {
        const dotIndex = file.name.lastIndexOf('.');
        const name = dotIndex !== -1 ? file.name.substring(0, dotIndex) : file.name;
        const extension = dotIndex !== -1 ? file.name.substring(dotIndex) : '';
  
        const renamed = new File([file], `${name} (1)${extension}`, {
          type: file.type,
          lastModified: file.lastModified,
        });
  
        newFile = renamed;
      }
  
      const form = new FormData();
      form.append('file', newFile);
      setUploadForm(form);
    } else {
      setUploadForm(null);
    }
  };
  
  const disabled = isNil(uploadForm);

  const renderContent = () => {
    return (
      <div style={{marginTop:"1rem"}}>
        <div className="content-paragraph">
          <div>
            {/* <div className="mb-2">{description}</div> */}
            <span>
              Πρόκειται να ενημερώσετε το Επενδυτικό Σχέδιο της αίτησης. Ανεβάστε στο ακόλουθο πεδίο το νέο Επενδυτικό Σχέδιο.
            </span>
            <br></br>
            <br></br>
              Παρακαλούμε επιβεβαιώστε την ενέργεια πατώντας Ενημέρωση διαφορετικά επιλέξτε Ακύρωση. 
            <Upload
              // style={{marginTop:"2rem"}}
              id="upload-ktp-partial"
              reset={resetUpload}
              item={{
                fileCode: fileCode,
                // required: true,
                label: (
                  <span style={{marginTop:"2rem"}}>
                    <b>{title}</b>
                    <span className="color-red"> *</span>
                    {/* <text style={{ fontWeight: 'normal', fontSize: '11px' }}>
                      (Κατεβάστε το υπόδειγμα του αρχείου{' '}
                      <button
                        id='download-provider-voucher-status-excel-button'
                        type="button"
                        style={{
                          textDecoration: 'underline',
                          background: 'none',
                          border: 'none',
                          color: 'blue',
                          cursor: 'pointer',
                          padding: 0,
                        }}
                        onClick={() => saveAs(docProvider, 'Υπόδειγμα Reserve/Redeem Vouchers')}
                      >
                        εδώ
                      </button>
                      )
                    </text> */}
                  </span>
                ),
                fileAccepts: fileAccepts,
              }}
              group={'documents'}
              mode="ktp-uploads"
              handleFile={handleFile}
            />
          </div>
        </div>
      </div>
    );
  };

  const submit = () => {
    payload = uploadForm;
    // console.debug({ payload });
    handleSubmit(payload);
    clearModal();
    setIsVisible(false);
  };

  return (
    <>
      <Modal
        isVisible={isVisible}
        handleCancel={() => {
          clearModal();
          setIsVisible(false);
        }}
        handleConfirm={submit}
        width={700}
        cancelText={cancelText ?? 'Ακύρωση'}
        okText={okText ?? 'Ενημέρωση'}
        submitDisabled={disabled}
        formKey={formKey}
        // Icon={Icon ?? WarningBlue}
        title={<span className="fileTitleLarge">
                Ενημέρωση Επενδυτικού Σχεδίου
              </span>}  
        outcome={outcome}
        user={user}
      >
        <div className="modal-submit-content">{renderContent()}</div>
      </Modal>
    </>
  );
};

export default UploadSingleFileModal;
